<template>
    <x-form ref="productForm" @submit.prevent="submit">
        <product-questions
            v-model="submission"
            :facilities="facilities"
            :commitment="commitment"
            :currentStep="currentStep"
            @form:reset-validation="resetValidation"
        >
            <template v-slot:submit-row>
                <x-layout class="action-set" align-center>
                    <x-flex xs6 offset-xs3 class="action-set-actions">
                        <x-container fluid>
                            <x-layout>
                                <x-flex xs6>
                                    <x-btn
                                        v-if="submission.id > 0"
                                        class="mr-4"
                                        color="tertiary"
                                        @click="$emit('submission:navigate-to', currentStep - 1)"
                                    >
                                        <i class="material-icons mr-2">arrow_back</i>

                                        Back
                                    </x-btn>

                                    <x-btn
                                        v-else
                                        class="mr-4"
                                        color="tertiary"
                                        @click="$emit('submission:cancel')"
                                    >
                                        <i class="material-icons mr-2">arrow_back</i>

                                        Cancel
                                    </x-btn>

                                    <delete-quote-button v-if="submission.status === 'draft'" :submissionId="submission.id" />
                                </x-flex>

                                <x-flex xs6 text-xs-right>
                                    <x-btn
                                        class="wide ma-0"
                                        color="primary"
                                        type="submit"
                                        data-test="next"
                                    >
                                        Next

                                        <i class="material-icons ml-2">trending_flat</i>
                                    </x-btn>
                                </x-flex>
                            </x-layout>
                        </x-container>
                    </x-flex>
                </x-layout>
            </template>
        </product-questions>
    </x-form>
</template>

<script>
    import ProductQuestions from '~/components/Broker/Products/ProductQuestions';
    import DeleteQuoteButton from '~/components/Broker/UIComponents/DeleteQuoteButton';

    export default {
        name: 'Product',
        components: {
            ProductQuestions,
            DeleteQuoteButton,
        },
        props: ['value', 'currencyCode', 'facilities', 'currentStep', 'commitment'],
        computed: {
            submission: {
                get() {
                    return this.value;
                },
                set(submission) {
                    this.$emit('input', submission);
                }
            },
        },
        watch: {
            value: {
                handler() {
                    this.$emit('input', this.value);
                },
                deep: true
            },
        },
        methods: {
            resetValidation() {
                this.$refs.productForm.resetValidation();
            },
            submit() {
                if (this.$refs.productForm.validate()) {
                    this.$emit('submission:navigate-to', this.currentStep + 1);
                }
            }
        }
    }
</script>
